import React from 'react';

import { Chip, MenuItem } from 'components';

import { i18n, useTranslation } from 'third-party';

import { ListFilter } from 'components/Table/Filtering/ListFilter';
import { ColumnFilteringProps, TableColumn } from 'components/Table/types';

import { formatDateTimeWithTimezone } from 'utils/app';

import { APIApiClientToken } from 'types/api';

export const TokenStatusFilter: React.FC<ColumnFilteringProps> = props => {
  const { t } = useTranslation();
  return (
    <ListFilter {...props}>
      <MenuItem key="all" value={undefined}>
        {t('common.all')}
      </MenuItem>
      <MenuItem key="active" value={true as any}>
        {t('apiTokens.status.active')}
      </MenuItem>
      <MenuItem key="disabled" value={false as any}>
        {t('apiTokens.status.disabled')}
      </MenuItem>
    </ListFilter>
  );
};

export const apiClientTokenColumns = (
  timezoneValue: string,
): TableColumn<APIApiClientToken>[] => [
  {
    dataId: 'name',
    label: i18n.t('apiTokens.column.name'),
    minWidth: 140,
    width: 200,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'token',
    label: i18n.t('apiTokens.column.token'),
    minWidth: 200,
    width: 300,
    hidden: false,
    sortable: false,
    resizable: true,
    filterType: 'string',
  },
  {
    dataId: 'isEnabled',
    label: i18n.t('apiTokens.column.status'),
    minWidth: 100,
    width: 120,
    hidden: false,
    sortable: true,
    resizable: true,
    customFilter: TokenStatusFilter,
    formatter: (value: boolean) => {
      const label = value
        ? i18n.t('apiTokens.status.active')
        : i18n.t('apiTokens.status.disabled');
      return {
        value: label,
        element: (
          <Chip
            label={label}
            color={value ? 'success' : 'default'}
            size="small"
          />
        ),
      };
    },
  },
  {
    dataId: 'expiresAt',
    label: i18n.t('apiTokens.column.expiresAt'),
    minWidth: 140,
    width: 180,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'date',
    formatter: value => ({
      value: value
        ? formatDateTimeWithTimezone(value as string, timezoneValue)
        : '—',
    }),
  },
  {
    dataId: 'lastUsedAt',
    label: i18n.t('apiTokens.column.lastUsedAt'),
    minWidth: 140,
    width: 180,
    hidden: false,
    sortable: true,
    resizable: true,
    formatter: value => ({
      value: value
        ? formatDateTimeWithTimezone(value as string, timezoneValue)
        : '—',
    }),
  },
  {
    dataId: 'createdOn',
    label: i18n.t('apiTokens.column.createdOn'),
    minWidth: 140,
    width: 180,
    hidden: false,
    sortable: true,
    resizable: true,
    filterType: 'date',
    formatter: value => ({
      value: formatDateTimeWithTimezone(value as string, timezoneValue),
    }),
  },
];
